import { Component, OnInit, Input } from '@angular/core';
import { ChartOptions, ChartDataSets, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label } from 'ng2-charts';
import { database } from 'firebase';

@Component({
    selector: 'odl-stats-report',
    templateUrl: './odl-stats-report.component.html',
    styleUrls: ['./odl-stats-report.component.scss']
})
export class OdlStatsReportComponent implements OnInit {
    
    dati_generali = [];
    dati_tipo_intervento = {};
    dati_tipo_cliente = {};

    display_generale = true;
    display_tipo_intervento = false;
    display_tipo_cliente = false;

    _show = 'generale';
    _data:any = {};

    @Input()
    set data(data:any) {
        this._data = data;
        this.dati_generali = this._data.generale ? this._data.generale.map( item => item) : null;
        this.dati_tipo_intervento = this._data.interventi ? Object.assign({},this._data.interventi) : null;
        this.dati_tipo_cliente = this._data.clienti ? Object.assign({},this._data.clienti) : null;
    }

    @Input()
    set show(name: string) {
        this._show = name;
        this.display_generale = false;
        this.display_tipo_intervento = false;
        this.display_tipo_cliente = false;
        switch (this._show) {
            case 'generale' :
                this.display_generale = true;
                break;
            case 'tipo_intervento':
                this.display_tipo_intervento = true;
                break;
            case 'tipo_cliente':
                this.display_tipo_cliente = true;
                break;
                
        }
    }

    constructor() { }

    ngOnInit() {
        
    }

}
